/* Progressive enhancement port of shared/Reveal.tsx. Opt in only where the source uses Reveal. */
(() => {
  'use strict';
  if (window.WingsReveal) return;
  const seen = new WeakSet();
  const active = new Map();
  const defaults = {heading: '0px 0px -100px 0px', items: '-50px 0px', fade: '0px'};
  const number = (value, fallback) => value !== undefined && Number.isFinite(Number(value)) ? Math.max(0, Number(value)) : fallback;
  function enhance(node) {
    if (seen.has(node) || node.dataset.reveal === 'shown') return;
    seen.add(node);
    const kind = node.dataset.wingsReveal;
    if (!(kind in defaults) || !('IntersectionObserver' in window)) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (motion.matches) { delete node.dataset.reveal; return; }
    if (node.dataset.reveal !== 'armed' && node.getBoundingClientRect().top < (window.innerHeight || document.documentElement.clientHeight)) return;
    const observers = [];
    let timer;
    let stopped = false;
    const stop = () => {
      stopped = true;
      observers.forEach((observer) => observer.disconnect());
      window.clearTimeout(timer);
      motion.removeEventListener('change', onMotionChange);
      active.delete(node);
    };
    const unarm = () => { stop(); delete node.dataset.reveal; };
    const reveal = () => {
      if (stopped) return;
      stop();
      if (kind === 'items') {
        const stagger = number(node.dataset.revealStagger, 0.05);
        [...node.children].forEach((child, index) => { child.style.transitionDelay = `${index * stagger}s`; });
      } else if (kind === 'fade') node.style.transitionDuration = `${number(node.dataset.revealDuration, 0.25)}s`;
      node.dataset.reveal = 'shown';
    };
    function onMotionChange(event) { if (event.matches) unarm(); }
    try {
      observers.push(new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) reveal();
      }, {rootMargin: node.dataset.revealMargin || defaults[kind]}));
      observers.push(new IntersectionObserver((entries) => {
        window.clearTimeout(timer);
        if (!stopped && entries.some((entry) => entry.isIntersecting)) timer = window.setTimeout(reveal, 700);
      }));
      node.dataset.reveal = 'armed';
      observers.forEach((observer) => observer.observe(node));
    } catch {
      unarm();
      return;
    }
    motion.addEventListener('change', onMotionChange);
    active.set(node, unarm);
  }
  function initialize(root = document) {
    for (const [node, cleanup] of active) if (!node.isConnected) cleanup();
    const nodes = [...root.querySelectorAll('[data-wings-reveal]')];
    if (root.matches?.('[data-wings-reveal]')) nodes.unshift(root);
    nodes.forEach(enhance);
  }
  window.WingsReveal = {init: initialize};
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [node, cleanup] of active) if (event.target.contains(node)) cleanup();
  });
})();
